"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _DatasetMetrics = _interopRequireDefault(require("./DatasetMetrics"));

var _DatasetXAxis = _interopRequireDefault(require("./DatasetXAxis"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The Dataset model module.
 * @module model/Dataset
 * @version 0.2.0
 */
var Dataset = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Dataset</code>.
   * @alias module:model/Dataset
   */
  function Dataset() {
    _classCallCheck(this, Dataset);

    Dataset.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(Dataset, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>Dataset</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Dataset} obj Optional instance to populate.
     * @return {module:model/Dataset} The populated <code>Dataset</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Dataset();

        if (data.hasOwnProperty('x_axis')) {
          obj['x_axis'] = _DatasetXAxis["default"].constructFromObject(data['x_axis']);
        }

        if (data.hasOwnProperty('metrics')) {
          obj['metrics'] = _ApiClient["default"].convertToType(data['metrics'], [_DatasetMetrics["default"]]);
        }
      }

      return obj;
    }
  }]);

  return Dataset;
}();
/**
 * @member {module:model/DatasetXAxis} x_axis
 */


Dataset.prototype['x_axis'] = undefined;
/**
 * @member {Array.<module:model/DatasetMetrics>} metrics
 */

Dataset.prototype['metrics'] = undefined;
var _default = Dataset;
exports["default"] = _default;